import React, {Component} from 'react'
import Report from "../../Report/Report";
import './FirstInputModule.sass'

class FirstInputModule extends Component {
  componentDidMount() {

    const $form = document.querySelector('.params-form')
    const $steelType = document.querySelector('.steelType')

    const values = JSON.parse(localStorage.getItem('InputParams1')) || {}
    if (values.length && values.width && values.material) {
      $form.length.value = values.length
      $form.width.value = values.width
      $form.material.value = values.material
      $form.polMethod.value = values.polMethod
      $steelType.innerText = values.material.split(' ')[0].split('|').join(' ')


    }

  }

  selectHandler = event => {
    const steelType = event.target.value.split(' ')[0].split('|').join(' ')
    console.log(steelType)

    document.querySelector('.params-label__value')
      .innerText =  steelType
  }

  clickHandleMainMod = event => {
    const $form = document.querySelector('.params-form')

    let diskParams = '24А 25 С2 К5'

    // 'закаленная'
    // '24А 25 С2 К5'
    // 'незакаленная'
    // '24A 25 CT2 K5'

    if ($form.polMethod.value === 'незакаленная') {
      diskParams = '24A 25 CT2 K5'
    }

    console.log($form.polMethod.value)

    localStorage.setItem('InputParams1', JSON.stringify({
      material: $form.material.value,
      length: $form.length.value,
      width: $form.width.value,
      polMethod: $form.polMethod.value,
      diskParams: diskParams
    }))
  }


  render() {
    return (
      <React.Fragment>>
        <main className='params'>

          <h1 className='params__title'>Ввод Параметров заготовки</h1>

          <form className='params-form' action="/action">
            <div className='params-content'>

              <div className="params-content-box">
                <h2 className='params-content__subtitle'>Обрабатываемый материал</h2>

                <div className="params-content-descr">

                  <div className="params-label">
                    <label className='params-label__item' htmlFor="material">Марка обрабатываемого материала</label>
                    <select onChange={this.selectHandler} name="material" className='params-label__select' id="material">
                      <option value="Конструкционные|стали Сталь|20Х">Сталь 20Х</option>
                      <option value="Конструкционные|стали Сталь|30Х">Сталь 30Х</option>
                      <option value="Конструкционные|стали Сталь|35">Сталь 35 </option>
                      <option value="Конструкционные|стали Сталь|35Х">Сталь 35Х</option>
                      <option value="Конструкционные|стали Сталь|40">Сталь 40</option>
                      <option value="Конструкционные|стали Сталь|40Х">Сталь 40Х</option>
                      <option value="Конструкционные|стали Сталь|45">Сталь 45</option>
                      <option value="Конструкционные|стали Сталь|45Х">Сталь 45Х</option>
                      <option value="Конструкционные|стали Сталь|18XГ">Сталь 18XГ</option>
                      <option value="Конструкционные|стали Сталь|65Г">Сталь 65Г</option>
                      <option value="Легированные|стали 10Х23Н18">10Х23Н18</option>
                      <option value="Легированные|стали 20Х23Н18">20Х23Н18</option>
                      <option value="Легированные|стали 12Х18Н10Т">12Х18Н10Т</option>
                      <option value="Легированные|стали 12Х21Н5Т">12Х21Н5Т</option>
                      <option value="Легированные|стали 40Х13">40Х13</option>
                      <option value="Легированные|стали 12Х13">12Х13</option>
                      <option value="Легированные|стали 95Х13">95Х13</option>
                      <option value="Легированные|стали 20Х13">20Х13</option>
                      <option value="Легированные|стали 30Х13">30Х13</option>
                      <option value="Легированные|стали 07Х16Н6">07Х16Н6</option>
                    </select>
                  </div>

                </div>

                <div className="params-content-descr">
                  <div className="params-label">
                    <label className='params-label__item' htmlFor="material">Группа обрабатываемого материала</label>
                    <span className='params-label__value steelType' id="material">
                      Конструкционные стали
                    </span>
                  </div>
                </div>
              </div>

              <div className="params-content-box">
                <h2 className='params-content__subtitle'>Габаритные размеры</h2>

                <div className="params-content-descr">

                  <div className="params-label">
                    <label className='params-label__item' htmlFor="length">Длина заготовки, мм </label>
                    <input
                      defaultValue="15"
                      name="length"
                      className='params-label__select'
                      id="length"
                    />
                  </div>

                </div>

                <div className="params-content-descr">
                  <div className="params-label">
                    <label className='params-label__item' htmlFor="width">Ширина заготовки, мм</label>
                    <input
                      defaultValue="15"
                      name="width"
                      className='params-label__value'
                      id="width"
                    />
                  </div>
                </div>


              </div>

              <div className="params-content-box">
                <h2 className='params-content__subtitle'>Термообработка</h2>

                <div className="params-content-descr">

                  <div className="params-label">

                    <label className='params-label__checkbox' htmlFor="length">
                      <input
                        checked
                        onChange={() => console.log('Changed')}
                        name='polMethod'
                        className='params-label__checkbox__elem'
                        type='radio'
                        value='закаленная'
                      />
                      Закаленная
                    </label>

                    <label className='params-label__checkbox' htmlFor="length">
                      <input
                        name='polMethod'
                        className='params-label__checkbox__elem'
                        type='radio'
                        value='незакаленная'
                      />
                      Незакаленная
                    </label>

                  </div>

                </div>

              </div>

            </div>
          </form>

        </main>
        <Report showSave={true} onClick={this.clickHandleMainMod}/>
      </React.Fragment>
    )
  }
}

export default FirstInputModule